import React from 'react';
import { ProviderConsumer } from '@fluentui/react-northstar';

/**
 * The line under a form field that needs attention ("Required field must be filled out."): the theme's own red,
 * which Teams sets per theme - softer and readable on dark grey (about 4.5:1), deep on white - at 12px, a hint under
 * the field rather than a second label. Tailwind's text-red-700 was a brick red made for white pages: about 2.2:1 on
 * Tikit's dark grey, muddy and hard to read (Shaun, 2026-10-19).
 */
export const FieldErrorText = ({ children }: { children: React.ReactNode }) => (
  <ProviderConsumer
    render={globalTheme => (
      <div role="alert" style={{ color: globalTheme.siteVariables.colorScheme.red.foreground, fontSize: 12, marginTop: 2 }}>
        {children}
      </div>
    )}
  />
);

/**
 * A required field's asterisk in the theme's red - the same red as FieldErrorText, softer on dark grey than pure red.
 * Used on the ticket page and its custom properties; the app's other forms keep their pure red (Shaun, 2026-10-16).
 */
export const RequiredAsterisk = () => (
  <ProviderConsumer
    render={globalTheme => <span aria-hidden style={{ color: globalTheme.siteVariables.colorScheme.red.foreground, marginLeft: 2 }}>*</span>}
  />
);
